export default function ReturnsRefunds() {
  return (
    <main className="min-h-screen bg-[#f0f4f7]">
      <section className="bg-[#2c2a4a] py-14 md:py-20">
        <div className="container-main text-center">
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3">Returns & Refunds</h1>
          <p className="text-white/70 text-base md:text-lg">We stand behind every piece of art we sell.</p>
        </div>
      </section>

      <section className="py-10 md:py-14">
        <div className="container-main max-w-3xl">
          <div className="space-y-8 text-[#4A4A4A] font-sans text-base leading-relaxed">
            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">30-Day Return Policy</h2>
              <p>
                We want you to love your SpinWorld.Us purchase. If you are not completely satisfied, we accept returns within <strong className="text-[#1A1A1A]">30 days</strong> of delivery for a full refund or exchange. Items must be unused, in original condition, and in the original packaging. Wind spinners must not be bent or damaged.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Return Shipping Costs</h2>
              <p>
                Return shipping costs are the responsibility of the customer unless the item arrived damaged or defective. We recommend using a trackable shipping service or purchasing shipping insurance for items over $50. We cannot guarantee that we will receive your returned item if you do not use a trackable method.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">How to Initiate a Return</h2>
              <p>
                To start a return, please contact us at <a href="mailto:Spinworld@myyahoo.com" className="text-[#4f528d] hover:underline">Spinworld@myyahoo.com</a> or call <a href="tel:907-500-8881" className="text-[#4f528d] hover:underline">907-500-8881</a> with your order number and reason for return. We will provide you with a return shipping address and instructions. Please do not send items back without contacting us first.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Damaged or Defective Items</h2>
              <p>
                If your order arrives damaged or defective, please contact us within <strong className="text-[#1A1A1A]">48 hours</strong> of delivery with photos of the damaged item and packaging. We will promptly replace the item at no cost or issue a full refund, including return shipping. We take great care in packaging, but sometimes transit can be rough.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Refund Processing</h2>
              <p>
                Once we receive your returned item and verify its condition, we will process your refund within <strong className="text-[#1A1A1A]">5-7 business days</strong>. Refunds are issued to the original payment method. Please note that it may take an additional 3-5 business days for the refund to appear on your statement depending on your bank or card issuer.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Non-Returnable Items</h2>
              <p>
                Custom or personalized orders cannot be returned unless they arrive damaged or defective. Items that have been used, altered, or damaged by the customer are not eligible for return. Gift cards are non-refundable.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Exchanges</h2>
              <p>
                If you would like to exchange an item for a different design, size, or color, please initiate a return for the original item and place a new order for the desired item. This ensures the fastest turnaround time and guarantees availability of your preferred replacement.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}